import React from 'react';
import PropTypes from 'prop-types';
import gql from 'graphql-tag';
import {Query} from 'react-apollo';
import {normalizeObject} from 'utils/misc';
import NetworkError from 'components/GraphQLError/NetworkError/index';


export const GET_AUTHENTICATED_ORGANIZATION_QUERY = gql`
query getAuthenticatedOrganization {
  authenticatedOrganization {
    id
    name
    logo
  }
}
`;


export const organizationShape = PropTypes.shape({
    alvaModules: PropTypes.array,
    dataTypes: PropTypes.array,
    id: PropTypes.string,
    name: PropTypes.string
});

export const organizationDataShape = PropTypes.shape({
    loading: PropTypes.bool,
    data: organizationShape,
    error: PropTypes.object
});

export class WithOrganization extends React.Component {
    static propTypes = {
        renderIfLoading: PropTypes.bool,
        children: PropTypes.func.isRequired,
        onError: PropTypes.func
    };

    static defaultProps = {
        renderIfLoading: true,
        onError: (error, refetch) => <NetworkError error={error} refetch={refetch}/>
    };

    render() {
        return (
            <Query query={GET_AUTHENTICATED_ORGANIZATION_QUERY} notifyOnNetworkStatusChange={true}>
                {({data, loading, error, refetch, client}) => {
                    if (error) {
                        return this.props.onError(error, refetch);
                    }

                    if (loading && !this.props.renderIfLoading) {
                        return null;
                    }

                    const {authenticatedOrganization} = data;

                    const organization = authenticatedOrganization ? normalizeObject(authenticatedOrganization) : null;

                    return this.props.children({loading, error, organization, refetch, client});
                }}
            </Query>
        );
    }
}


export function withOrganization(WrappedComponent, renderIfLoading = true) {
    class InnerWithOrganization extends React.Component {

        render() {

            return (
                <WithOrganization renderIfLoading={renderIfLoading}>
                    {({error, loading, organization}) => <WrappedComponent organization={{
                        error,
                        loading,
                        data: organization
                    }} {...this.props}/>}
                </WithOrganization>
            );

        }
    }

    return InnerWithOrganization;
}
